import { render, staticRenderFns } from "./AffiliateComments.vue?vue&type=template&id=05023c90&scoped=true"
import script from "./AffiliateComments.vue?vue&type=script&lang=js"
export * from "./AffiliateComments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05023c90",
  null
  
)

export default component.exports